<div class="p-grid">
	<div class="p-col-12 p-lg-4 d-flex flex-column">
		<div class="btn btn-primary w-100" (click)="orderTypeThrottleAdd()">Add Throttle</div>
		<div class="me-3">Enabled</div>
		<div class="me-3">
			<p-inputSwitch [(ngModel)]="orderType.throttle"> </p-inputSwitch>
		</div>
		<div *ngIf="orderType.throttle" class="me-3">Sample Minutes</div>
		<div *ngIf="orderType.throttle">
			<p-inputNumber (onInput)="changesToSaveChange.emit(true)" styleClass="w-100" [(ngModel)]="orderType.throttleSampleMinutes"> </p-inputNumber>
		</div>
	</div>
	<div class="p-col-12 p-lg-8 d-flex flex-column">
		<ng-container *ngFor="let throttle of orderType.ooOrderTypeThrottles; let idx = index">
			<div class="d-flex flex-column">
				<div class="d-flex mb-3 align-items-center">
					<div class="me-3">Active</div>
					<div class="me-3">
						<p-inputSwitch (onChange)="changesToSaveChange.emit(true)" [(ngModel)]="throttle.active"> </p-inputSwitch>
					</div>
					<div class="ms-auto">
						<button pButton type="button" label="X" class="p-button-danger" (click)="deleteThrottle(throttle)"></button>
					</div>
				</div>

				<div class="d-flex align-items-center mb-3">
					<div class="me-3">Lead Time Minutes</div>
					<div class="ms-auto">
						<p-inputNumber
							(onInput)="changesToSaveChange.emit(true)"
							styleClass="w-100"
							[(ngModel)]="throttle.throttleOrderMinutes"
							[disabled]="!throttle.active"
							pTooltip="How long you want the new lead time to be when this Throttling Rule is triggered."
						>
						</p-inputNumber>
					</div>
				</div>

				<div class="d-flex align-items-center mb-3">
					<div class="me-3">
						Order Count
						<div style="font-size: xx-small">How many orders within the <i>Sample Minutes</i> should cause this rule to trigger?</div>
					</div>
					<div class="ms-auto">
						<p-inputNumber
							styleClass="w-100"
							[(ngModel)]="throttle.throttleOrderCount"
							[disabled]="!throttle.active || throttle.throttleOrderRevenue > 0"
							(onInput)="changesToSaveChange.emit(true)"
						>
						</p-inputNumber>
					</div>
				</div>

				<div class="d-flex align-items-center mb-3">
					<div class="me-3">
						Revenue
						<div style="font-size: x-small">Orders that meet or exceed this amount will cause this rule to trigger.</div>
					</div>
					<div class="ms-auto">
						<p-inputNumber
							styleClass="w-100"
							[(ngModel)]="throttle.throttleOrderRevenue"
							mode="decimal"
							[minFractionDigits]="2"
							[minFractionDigits]="2"
							[disabled]="!throttle.active || throttle.throttleOrderCount > 0"
							(onInput)="changesToSaveChange.emit(true)"
						>
						</p-inputNumber>
					</div>
				</div>

				<div class="d-flex align-items-center mb-3">
					<div class="me-3">
						<p-checkbox
							label="Time based rule"
							(onChange)="changesToSaveChange.emit(true)"
							[(ngModel)]="throttle.timeBased"
							[binary]="true"
							labelStyleClass="mt-2"
							styleClass="ms-4"
						>
						</p-checkbox>
					</div>
				</div>

				<div class="d-flex align-items-center mb-3" *ngIf="throttle.timeBased">
					<div class="me-3">
						Start Time
						<div style="font-size: x-small">Rule start time in 24-hour format (i.e. 14:00)</div>
					</div>
					<div class="ms-auto">
						<input
							pInputText
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
							type="text"
							[(ngModel)]="throttle.startTime"
							[disabled]="!throttle.active"
						/>
					</div>
				</div>
				<div class="d-flex align-items-center mb-3" *ngIf="throttle.timeBased">
					<div class="me-3">
						End Time
						<div style="font-size: x-small">Rule end time in 24-hour format (i.e. 14:00)</div>
					</div>
					<div class="ms-auto">
						<input
							pInputText
							class="w-100"
							(change)="changesToSaveChange.emit(true)"
							type="text"
							[(ngModel)]="throttle.endTime"
							[disabled]="!throttle.active"
						/>
					</div>
				</div>
			</div>
			<p-divider></p-divider>
		</ng-container>
	</div>
</div>
